import { getColor } from 'helpers';

import { styled } from '../styled';
import { ColorsDark, ColorsLight } from '../theme';

export const ContainerStyled = styled('div')<{ separatedRows?: boolean }>(
  ({ theme, separatedRows }) => ({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    ...(separatedRows
      ? {
          rowGap: 16,
        }
      : {
          border: `1px solid ${getColor(theme, {
            dark: ColorsDark.gray100,
            light: ColorsLight.gray150,
          })}`,
          borderRadius: 8,
          overflow: 'hidden',
        }),
  })
);

export const RowContainerStyled = styled('div')<{
  labelsColumnMinWidth?: string;
}>(({ theme, labelsColumnMinWidth }) => ({
  display: 'grid',
  gridColumn: '1 / -1',
  gridTemplateColumns: `minmax(${
    labelsColumnMinWidth || 'auto'
  }, 1fr) minmax(0, 1fr)`,
  border: `1px solid ${getColor(theme, {
    dark: ColorsDark.gray100,
    light: ColorsLight.gray150,
  })}`,
  borderRadius: 8,
  overflow: 'hidden',
}));

export const ColumnStyled = styled('div')<{
  isLastColumn: boolean;
  isLastRow: boolean;
  separatedRows: boolean;
}>(({ theme, isLastColumn, isLastRow, separatedRows }) => ({
  padding: '10px 12px',
  borderBottom:
    isLastRow && isLastColumn
      ? 'none'
      : `1px solid ${getColor(theme, {
          dark: ColorsDark.gray100,
          light: ColorsLight.gray150,
        })}`,
  borderBlockWidth: !separatedRows && !isLastRow && isLastColumn ? 3 : 1,

  backgroundColor: getColor(theme, {
    dark: ColorsDark.gray50,
    light: ColorsLight.gray50,
  }),
  borderRight: `1px solid ${getColor(theme, {
    dark: ColorsDark.gray100,
    light: ColorsLight.gray150,
  })}`,

  '.tableMobile-column-title': {
    color: getColor(theme, {
      dark: ColorsDark.gray250,
      light: ColorsLight.gray300,
    }),
  },
}));

export const RowStyled = styled('div')<{
  isLastColumn: boolean;
  isLastRow: boolean;
  separatedRows: boolean;
}>(({ theme, isLastColumn, isLastRow, separatedRows }) => ({
  padding: '10px 12px',
  borderBottom:
    isLastRow && isLastColumn
      ? 'none'
      : `1px solid ${getColor(theme, {
          dark: ColorsDark.gray100,
          light: ColorsLight.gray150,
        })}`,
  borderBlockWidth: !separatedRows && !isLastRow && isLastColumn ? 3 : 1,
}));
